import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Radio, Input, Tabs, DatePicker, Select, Icon} from 'antd';

const TabPane = Tabs.TabPane;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView} from '../../components';
import {openNotice, APIS, proLineSet} from 'Utils';
import {
    getPro,
    getProTypes,
    create,
    fetchSpecList,
    fetchCompany,
    addCar,
    getProductCategory,
    getCrmAccount
} from '../../service/customOrder';
import {customerList} from '../../service/shoppingCar';
import './corder.css';
import moment from 'moment';
import {Cascader} from 'antd';
import {getGouXiaoUnitList} from "../../service/specialOrder";

const Option = Select.Option;
const customPrefix = '$radioVal_';
let uuid = 0;
let timeout;

function fetchCrmAccount(value, callback) {
    if (timeout) {
        clearTimeout(timeout);
        timeout = null;
    }

    function fake() {
        getCrmAccount(value).then(result => {
            if (result.status && result.code == 200) {
                const data = [];
                result.data.forEach((r) => {
                    data.push({
                        value: r.ACCOUNT_NAME,
                        text: r.ACCOUNT_NAME,
                    });
                });
                callback(data);
            }
        })
    }

    timeout = setTimeout(fake, 1000);
}

class CustomOrderAdd extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        const session_key = props.location.query.session_key || undefined;
        if (session_key) {
            this.orderSession = JSON.parse(window.sessionStorage.getItem(session_key));
        }
        // window.sessionStorage.getItem()
        this.state = {
            opts: ['定制订单'],
            loading: false,
            key: 0,
            channelCode: this.channelData.split('|')[1] || '',
            // 选择产品类别
            selectedRowKeys: [],
            selectedRowKeysOutside: [],
            addRows: [],
            addTotal: 1,
            addSearchObj: {
                s: 5,
                p: 1
            },
            subDisabled: false,
            // 新增点击保存用到 TODO
            add: {
                id: 1,
                subdivideProLine: '',
                proBigType: '',
                proMiddleType: '',
                proDetailType: '',
                // 规格
                specifications: '',
                // 后台要求传的两条冗余数据 start
                specUnionKey: '',
                proContent: '',
                // 后台要求传的两条冗余数据 end
                remark: '',
                proCompany: '', // TODO
                proCompanyId: '', // TODO
                count: 1,
                needDate: moment(new Date(), 'YYYY-MM-DD'),

                // 冗余数据，提交时用，勿删
                createdBy: JSON.parse(window.localStorage.getItem('login_user_information')).id,
                createdDate: new Date().getTime(), // TODO
                proLine: '', // 选择radio时赋值
                productCode: '', // 为空 TODO
                productName: '', // 为空 TODO
                removeFlag: 0,
                environmentalAttributes: '' //环保属性
            },
            options1: [],
            mainSpec: [],
            slaveSpec: [],
            submitRows: [],
            proLine: '',
            proBigType: '',
            proDetailType: '',
            alreadyRows: [],
            alreadyTotal: 1,
            alreadySearchObj: {
                s: 10,
                p: 1
            },
            informationProps: {
                /* 产品资料 */
                name: 'file',
                action: APIS.upload,
                onChange: this.updateInformation.bind(this),
                showUploadList: false,
                defaultFileList: [],
            },
            rows: [],
            total: 1,
            searchObj: {
                s: 10,
                p: 1
            },
            //李 新增
            lastsearch: '',
            categoryData: [],
            visible: false,
            // 联系电话
            phone: '',
            remark: '',
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}'),
            company: [],
            selectcompany: '',
            informationLi: [],
            cascaderOption: [],
            categoryCascaderValue: [],
            gouxiaoUnitList: [],
            salesUnitId: '',
            crmAccount: '',
            sumC: {
                bentiMsg: [],
                fujianMsg: [],
                p: 1,
                s: 10
            },
            crmAccountList: []
        };
    };

    updateInformation(result) {
        let informationLi = this.state.informationLi || [];
        if (result.file.status === 'done') {
            let responseData = result.file.response || {};
            if (responseData.code != 200) {
                openNotice('error', '附件上传失败');
                return;
            }
            informationLi[0] = {
                id: responseData.data.id,
                fileName: responseData.data.fileName,
            }
        }
        this.setState({
            informationLi: informationLi
        })
    };

    deleteInformation(index) {
        /* 删除产品资料 */
        const {informationLi} = this.state;
        informationLi.splice(index, 1);
        this.setState({
            informationLi: informationLi
        });
    };

    goView(url) {
        hashHistory.push(url);
    }

    onOutsideSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({selectedRowKeysOutside: selectedRowKeys});
        // console.dir(selectedRows);
    }

    onSelfRow = (record, selected, selectedRows) => {
        // console.log(record);
        // console.log(selected);
        // console.log(selectedRows);
        // debugger;
        fetchCompany(selectedRows[0].categoryId).then(result => {
            if (result.status && result.code == 200) {
                this.setState({company: result.data});
                if (result.data.length > 1) {
                    this.setState({selectcompany: ''})
                } else {
                    this.setState({selectcompany: result.data[0].name})
                    this.setState({
                        add: {
                            ...this.state.add,
                            proCompany: result.data[0].name,
                            proCompanyId: result.data[0].id
                        }
                    });
                }
                ;
            }
        });
        // debugger
    }

    /*选择列表*/
    onSelectChange = (selectedRowKeys, selectedRows) => {
        // console.log(selectedRows);
        // debugger
        var self = this;
        this.doClear();
        this.setState({
            selectedRowKeys: selectedRowKeys,
            add: {
                ...this.state.add,
                specifications: [],
                specUnionKey: [],
                proContent: '',
                subdivideProLine: selectedRows[0].subdivideProLine,
                proBigType: selectedRows[0].proBigType,
                proMiddleType: selectedRows[0].proMiddleType,
                proDetailType: selectedRows[0].proDetailType,
                proLine: selectedRows[0].proLine
            }
        }, () => {
            self.getSpecList(selectedRows[0].categoryId);
        });
    };

    goBack() {
        hashHistory.goBack();
    };

    /*筛选*/
    setFilterParam = (name, value) => {
    };
    /*筛选重置*/
    advanceReset = () => {
    };
    /* 筛选确认 */
    advanceSubmit = (form) => {
    };

    /*翻页*/
    pageChange = (page, pageSize) => {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            // this.initData();
        });
    }

    addPageChange = (page, pageSize) => {
        this.setState({addSearchObj: {...this.state.addSearchObj, s: pageSize, p: page}}, function () {
            this.getAddArray();
        });
    }

    alreadyPageChange = (page, pageSize) => {
        this.setState({alreadySearchObj: {...this.state.alreadySearchObj, s: pageSize, p: page}}, function () {
            this.getAlreadyArray();
        });
    }

    // /*获取列表数据*/
    // initData() {
    // }

    //离开当前路由时，更新store
    routeLeaveHook = (nextLocation) => {
    }

    componentWillMount() {
        const self = this;
        const {channelCode} = this.state;
        customerList(channelCode).then(res => { //人员
            // debugger
            // console.log(res.data)
            if (res.data.length > 1) {
                self.setState({
                    options1: res.data,
                });
            } else {
                self.setState({
                    options1: res.data,
                    thirdId: res.data[0].thirdId,
                    customerUserId: res.data[0].customerUserId,
                    num: res.data[0].code,
                    name1: res.data[0].name
                });
            }
        });
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                const data = res.data || [];
                let arr = [];
                for (let i = 0; i < data.length; i++) {
                    let x = data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                if (data.length == 1) {
                    this.state.salesUnitId = res.data[0].id;
                }
                self.setState({gouxiaoUnitList: arr})
            }
        });
    }

    componentDidMount() {
        // this.initData();
        getProductCategory({
            id: ''
        }).then(result => {
            if (result.status && result.code == 200) {
                for (var i = 0; i < result.data.length; i++) {
                    for (var j = 0; j < result.data[i]['children'].length; j++) {
                        for (var z = 0; z < result.data[i]['children'][j]['children'].length; z++) {
                            delete result.data[i]['children'][j]['children'][z].children;
                        }
                    }
                }
                let list = result.data;
                this.setState({
                    cascaderOption: result.data,
                    visible: !!this.orderSession && !!this.orderSession.categoryId
                }, () => {
                    if (this.orderSession && this.orderSession.proBigType) {
                        let bigIndex, middleIndex, detailIndex = -1;
                        let selectedRowKeys = [];
                        let selectedRow = {};
                        let categoryNamePath = [];
                        for (var i = 0; i < list.length; i++) {
                            if (list[i].code === this.orderSession.proBigType) {
                                bigIndex = i;
                                categoryNamePath.push(list[i].label)
                            }
                            for (var j = 0; j < list[i]['children'].length; j++) {
                                if (list[i]['children'][j].code === this.orderSession.proMiddleType) {
                                    middleIndex = j;
                                    categoryNamePath.push(list[i]['children'][j].label)
                                }
                                for (var z = 0; z < list[i]['children'][j]['children'].length; z++) {
                                    if (list[i]['children'][j]['children'][z].code === this.orderSession.proDetailType) {
                                        detailIndex = z;
                                        selectedRowKeys = [list[i]['children'][j]['children'][z].categoryId];
                                        selectedRow = list[i]['children'][j]['children'][z];
                                        categoryNamePath.push(list[i]['children'][j]['children'][z].label)
                                    }
                                }
                            }
                        }
                        if (detailIndex != -1) {
                            // CascaderonChange = (value, selectedOptions)
                            let value = [
                                list[bigIndex].key,
                                list[bigIndex].children[middleIndex].key,
                                list[bigIndex].children[middleIndex].children[detailIndex].key
                            ]
                            let selectedOptions = [
                                list[bigIndex],
                                list[bigIndex].children[middleIndex],
                                list[bigIndex].children[middleIndex].children[detailIndex]
                            ]
                            this.CascaderonChange(value, selectedOptions)
                            this.setState({selectedRowKeys}, () => {
                                this.onSelectRow(selectedRow, () => {
                                    let arr = []
                                    let bentiMsg = (this.orderSession.bentiSpec || []).map(x => {
                                        arr.push(`${x.propertyName}:${x.propertyDesc}`);
                                        return {
                                            "categoryId": x.categoryId,
                                            "propertyNum": x.propertyNum,
                                            "propertyCategoryCode": "本体",
                                            "propertyDesc": x.propertyDesc,
                                            "name": x.propertyName
                                        }
                                    })
                                    let fujianMsg = (this.orderSession.fujianSpec || []).map(x => {
                                        arr.push(`${x.propertyName}:${x.propertyDesc}`);
                                        return {
                                            "categoryId": x.categoryId,
                                            "propertyNum": x.propertyNum,
                                            "propertyCategoryCode": "本体",
                                            "propertyDesc": x.propertyDesc,
                                            "name": x.propertyName
                                        }
                                    })
                                    let str = arr.toString();
                                    this.setState({
                                        sumC: {
                                            ...this.state.sumC,
                                            bentiMsg,
                                            fujianMsg,
                                        },
                                        add: {
                                            ...this.state.add,
                                            specifications: str,
                                            specUnionKey: str,
                                            proContent: str,
                                            subdivideProLine: this.orderSession.proLine || '',
                                            // proBigType: this.orderSession.proBigType,
                                            // proMiddleType: this.orderSession.proMiddleType,
                                            // proDetailType: this.orderSession.proDetailType,
                                            // proLine: this.orderSession.proLine
                                            proBigType: categoryNamePath[0] || '',
                                            proMiddleType: categoryNamePath[1] || '',
                                            proDetailType: categoryNamePath[2] || '',
                                            proLine: proLineSet.filter(x => x.value === this.orderSession.proLine)[0] ? proLineSet.filter(x => x.value === this.orderSession.proLine)[0].text : this.orderSession.proLine
                                        },
                                    });
                                });
                            });
                        }
                        // [{"categoryId":11253,"propertyName":"标准配置","propertyNum":"TGW45_BZPZ","propertyDesc":"相间隔板(1000壳架标配)，接线螺钉，水平接线"},{"categoryId":11253,"propertyName":"额定电流","propertyNum":"TGW45_EDDL","propertyDesc":"200A"},{"categoryId":11253,"propertyName":"分断能力","propertyNum":"TGW45_FDNL","propertyDesc":"普通型"},{"categoryId":11253,"propertyName":"分断能力值","propertyNum":"TGW45_FDNLZ","propertyDesc":"42kA"},{"categoryId":11253,"propertyName":"极数","propertyNum":"TGW45_JS","propertyDesc":"3P"},{"categoryId":11253,"propertyName":"壳架电流","propertyNum":"TGW45_KJDL","propertyDesc":"1000A"}]
                        // [{"categoryId":11253,"propertyNum":"TGW45_AZFS","propertyCategoryCode":"本体","propertyDesc":"抽屉垂直","name":"安装方式"}]
                    } /*else {
                        getProTypes({
                            proLine: this.state.proLine,
                            proBigType: this.state.proBigType,
                            proDetailType: this.state.proDetailType,
                            p: this.state.addSearchObj.p,
                            s: this.state.addSearchObj.s
                        }).then(result => {
                            if (result.status && result.code == 200) {
                                for (var i = 0; i < result.data.length; i++) {
                                    result.data[i].proLine = result.data[i].subdivideProLine
                                }
                                this.setState({
                                    addRows: result.data,
                                    addTotal: result.total,
                                    loading: false
                                });
                            } else {
                                openNotice('error', '获取产品类别失败', result.message || '');
                            }
                        });
                    }*/
                });


            } else {
                openNotice('error', '获取产品类别失败', result.message || '');
            }
        });
        if (this.orderSession && this.orderSession.categoryId) {
            this.getSpecList(this.orderSession.categoryId);
        }
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);

    }

    handleOk = () => {
        this.setState({visible: false});
        this.doClear();
    }

    handleCancel = () => {
        this.setState({visible: false});
        this.doClear();
    }

    onChange = (e) => {
        console.log('radio checked', e.target.value);
    }

    // giveMsg = (ele,index) => {
    // 	console.log(ele);
    // 	console.log(index);

    // }
    // addAB = () => {
    // 	var specificationsA = this.state.add.specificationsA|| '';
    // 	var specUnionKeyA = this.state.add.specUnionKeyA ||'';
    // 	var proContentA = this.state.add.proContentA ||'';
    // 	var specificationsB = this.state.add.specificationsB ||'';
    // 	var specUnionKeyB = this.state.add.specUnionKeyB ||'';
    // 	var proContentB = this.state.add.proContentB ||'';
    // 	var specifications = specificationsA+specificationsB;
    // 	var specUnionKey = specUnionKeyA+specUnionKeyB;
    // 	var proContent = proContentA+proContentB;
    // 	// console.log(specifications)
    // 	// debugger

    // 	this.setState({add: {...this.state.add, specifications: specifications, specUnionKey: specUnionKey, proContent: proContent}});
    // }

    radioBtnChange2 = (index, val, type, ele, i, e) => {
        const self = this;
        let prefix = type == 1 ? 'anotherPrefixSlave' : 'anotherPrefixMain';
        if (e.target.parentElement.parentElement.className.lastIndexOf('checked') > -1) {
            this.setState({[prefix + index]: {name: ele.propertyName, val: ''}}, () => {
                var arr = [];
                for (var ele in self.state) {
                    if (ele.indexOf('anotherPrefix') > -1 && self.state[ele].val) {
                        arr.push(self.state[ele].name + ': ' + self.state[ele].val);
                    }
                }
                var _str = arr.toString();
                self.setState({add: {...this.state.add, specifications: _str, specUnionKey: _str, proContent: _str}});
            });
        } else {
            this.setState({[prefix + index]: {name: ele.propertyName, val: val}}, () => {
                var arr = [];
                for (var ele in self.state) {
                    if (ele.indexOf('anotherPrefix') > -1 && self.state[ele].val) {
                        arr.push(self.state[ele].name + ': ' + self.state[ele].val);
                    }
                }
                var _str = arr.toString();
                self.setState({
                    add: {
                        ...this.state.add,
                        specifications: _str,
                        specUnionKey: _str,
                        proContent: _str
                    }
                });
            })
        }

        var sumC = {...this.state.sumC};
        var sumD = {...this.state.sumC};
        var x = sumD.bentiMsg.length;
        var y = sumD.fujianMsg.length;
        if (type == 0) {
            var sumA = {
                categoryId: ele.categoryId || '',
                propertyNum: ele.propertyNum || '',
                propertyCategoryCode: ele.propertyCategoryCode || '',
                propertyDesc: val || '',
                name: ele.propertyName || ''
            }
            sumC.bentiMsg.push(sumA);
            for (var i = 0; i < x; i++) {
                var sumBEN = sumC.bentiMsg[i];
                if (sumC.bentiMsg[i].name == ele.propertyName) {
                    sumC.bentiMsg.splice(i, 1, sumA);
                    if (sumBEN.propertyDesc == val) {
                        sumC.bentiMsg.splice(i, 1, 'undefined');
                        sumC.bentiMsg.pop();
                        sumC.bentiMsg.push('undefined');
                    }
                }
            }
        }
        if (type == 1) {
            var sumA = {
                categoryId: ele.categoryId || '',
                propertyNum: ele.propertyNum || '',
                propertyCategoryCode: ele.propertyCategoryCode || '',
                propertyDesc: val || '',
                name: ele.propertyName || ''
            }
            sumC.fujianMsg.push(sumA);
            for (var i = 0; i < y; i++) {
                var sumBEN = sumC.fujianMsg[i];
                if (sumC.fujianMsg[i].name == ele.propertyName) {
                    sumC.fujianMsg.splice(i, 1, sumA);
                    if (sumBEN.propertyDesc == val) {
                        sumC.fujianMsg.splice(i, 1, 'undefined');
                        sumC.fujianMsg.pop();
                        sumC.fujianMsg.push('undefined');
                    }
                }
            }
        }
        var hash = {};
        sumC.bentiMsg = sumC.bentiMsg.reduce(function (item, next) {
            hash[next.name] ? '' : hash[next.name] = true && item.push(next);
            return item
        }, [])
        sumC.fujianMsg = sumC.fujianMsg.reduce(function (item, next) {
            hash[next.name] ? '' : hash[next.name] = true && item.push(next);
            return item
        }, [])

        function clear_arr_trim(array) {
            for (var i = 0; i < array.length; i++) {
                if (array[i] == 'undefined' || array[i] == '' || typeof (array[i]) == 'undefined') {
                    array.splice(i, 1);
                    i = i - 1;
                }
            }
            return array;
        };
        clear_arr_trim(sumC.bentiMsg);
        clear_arr_trim(sumC.fujianMsg);
        sumC.channelCode = this.state.channelCode;
        getPro(sumC).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    alreadyRows: result.data,
                    alreadyTotal: result.total
                });
            } else {
                openNotice('error', '获取已有物料列表失败', result.message || '');
            }
        })
        this.setState({sumC: sumC});
    }

    radioOnChange2 = (e) => {
        let self = this;

        this.setState({[customPrefix + e.target.propertyNum]: e.target.value}, () => {
            var arr = [];
            // console.log(arr);
            for (let name in this.state) {
                if (name.indexOf(customPrefix) > -1) {
                    arr.push(this.state[name]);
                    arr = arr.filter(function (n) {
                        return n
                    })
                }
            }
            var _str = arr.toString();
        });
    }

    radioBtnChange = (index, val, type, e) => {
        console.dir(e.target)
        let self = this;
        let prefix = type == 1 ? 'anotherPrefixSlave' : 'anotherPrefixMain';
        // if (thisIndex === self.state.lastIndex && self.state['anotherPrefix' + index].count === 1) {
        // 	console.log('same');
        // 	// 点了同一个按钮，我们要把相应的state字段绑定值置为空
        // 	this.setState({['anotherPrefix' + index]: {name: e.target.name, val: '', count: 0}, lastIndex: thisIndex});
        // } else {
        // 	this.setState({['anotherPrefix' + index]: {name: e.target.name, val: val, count: 1}, lastIndex: thisIndex}, () => {
        // 		let _obj = self.state['anotherPrefix' + index];
        //     	console.log(_obj.name + ': \n\r' + _obj.val)
        //     })
        // }
        if (e.target.parentElement.parentElement.className.lastIndexOf('checked') > -1) {
            console.log('same');
            this.setState({[prefix + index]: {name: e.target.name, val: ''}}, () => {
                var arr = [];
                for (var ele in self.state) {
                    if (ele.indexOf('anotherPrefix') > -1 && self.state[ele].val) {
                        arr.push(self.state[ele].name + ': ' + self.state[ele].val);
                    }
                }
                // console.dir(arr)
                var _str = arr.toString();
                self.setState({
                    add: {
                        ...this.state.add,
                        specifications: _str,
                        specUnionKey: _str,
                        proContent: _str
                    }
                });
            });
        } else {
            this.setState({[prefix + index]: {name: e.target.name, val: val}}, () => {
                // let _obj = self.state['anotherPrefix' + index];
                // console.log(_obj.name + ': \n\r' + _obj.val)
                var arr = [];
                for (var ele in self.state) {
                    if (ele.indexOf('anotherPrefix') > -1 && self.state[ele].val) {
                        arr.push(self.state[ele].name + ': ' + self.state[ele].val);
                    }
                }
                // console.dir(arr)
                var _str = arr.toString();
                self.setState({
                    add: {
                        ...this.state.add,
                        specifications: _str,
                        specUnionKey: _str,
                        proContent: _str
                    }
                });
            })
        }

    }
    radioOnChange = (index) => {
        const self = this;
        // console.log(e);
        // console.log(index)

        this.setState({[customPrefix + index.target.id]: index.target.value}, () => {
            var arr = [];
            for (let name in this.state) {
                if (name.indexOf(customPrefix) > -1) {
                    // console.log()

                    arr.push(this.state[name]);
                    arr = arr.filter(function (n) {
                        return n
                    })
                }
            }
            var _str = arr.toString();
            // this.setState({add: {...this.state.add, specificationsA: _str, specUnionKeyA: _str, proContentA: _str}});
            // this.setState({add: {...this.state.add, specifications: _str, specUnionKey: _str, proContent: _str}});
        })
        // this.addAB();
        // var selected = {
        // 		propertyDescName:e.target.value,
        // 		id: e.target.id
        // };

        // this.setState({
        //  	selected: {
        //  		propertyDescName:index.target.value,
        //  		id: index.target.id
        // 	}
        // })
        var giveList = self.state.giveList;
        // console.log(giveList);
        // debugger
        // console.log(e.target);
        for (var i = 0; i <= giveList.bentiMsg.length - 1; i++) {
            giveList.bentiMsg[i].propertyDescName = [];
        }
        for (var i = 0; i <= giveList.fujianMsg.length - 1; i++) {
            giveList.fujianMsg[i].propertyDescName = [];
        }
        // console.log(giveList);
        for (var i = 0; i <= giveList.bentiMsg.length - 1; i++) {
            // console.log(giveList.bentiMsg[i].id);
            if (giveList.bentiMsg[i].id == index.target.id) {
                giveList.bentiMsg[i].propertyDesc = index.target.value;
            }
        }
        for (var i = 0; i <= giveList.fujianMsg.length - 1; i++) {
            // console.log(giveList.fujianMsg[i].id);
            if (giveList.fujianMsg[i].id == index.target.id) {
                giveList.fujianMsg[i].propertyDesc = index.target.value;
            }
        }
        delete giveList.id;
        delete giveList.ids;
        delete giveList.itemselector;
        delete giveList.orderField;
        delete giveList.orderString;
        delete giveList.reqType;

        // console.log(giveList);
        giveList.p = this.state.alreadySearchObj.p;
        giveList.s = this.state.alreadySearchObj.s;
        // self.setState({giveList})
        // console.log(giveList);

        // var giveList = self.state.giveList;
        // for (var i = 0; i< giveList.bentiMsg.length ; i++) {
        // 	console.log(giveList.bentiMsg[i])

        // }
        // console.table(giveList)
        //     alert(giveList)
        getPro(giveList).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    alreadyRows: result.data,
                    alreadyTotal: result.total
                });
            } else {
                openNotice('error', '获取已有物料列表失败', result.message || '');
            }
        })
    }
    // radioOnChange2 = (ele,e,index) => {
    // 	const self = this;
    // 	// console.log(e);
    // 	// console.log(index)

    // 	this.setState({[customPrefix + index.target.id]:this.state.slaveSpec[e].propertyName+':'+ index.target.value}, () => {
    // 		var arr = [];
    // 		for (let name in this.state) {
    // 			if (name.indexOf(customPrefix) > -1) {
    // 				// console.log()

    // 				arr.push(this.state[name]);
    // 				arr = arr.filter(function(n){return n})
    // 			}
    // 		}
    // 		var _str = arr.toString();
    // 		this.setState({add: {...this.state.add, specificationsB: _str, specUnionKeyB: _str, proContentB: _str}});
    // 	})
    // 	// var selected = {
    //  // 		propertyDescName:e.target.value,
    //  // 		id: e.target.id
    // 	// };
    // 	this.addAB();
    // 	this.setState({
    // 	 	selected: {
    // 	 		propertyDescName:index.target.value,
    // 	 		id: index.target.id
    // 		}
    // 	})
    // 	var giveList = self.state.giveList;
    // 	// console.log(giveList);
    // 	// debugger
    // 	// console.log(e.target);
    // 	for (var i = 0; i <= giveList.bentiMsg.length-1; i++) {
    // 		giveList.bentiMsg[i].propertyDescName = [];
    // 	}
    // 	for (var i = 0; i <= giveList.fujianMsg.length-1; i++) {
    // 		giveList.fujianMsg[i].propertyDescName = [];
    // 	}
    // 	// console.log(giveList);
    // 	for (var i = 0; i <= giveList.bentiMsg.length-1; i++) {
    // 		// console.log(giveList.bentiMsg[i].id);
    // 		if (giveList.bentiMsg[i].id == index.target.id) {
    // 			giveList.bentiMsg[i].propertyDesc = index.target.value;
    // 		}
    // 	}
    // 	for (var i = 0; i <= giveList.fujianMsg.length-1; i++) {
    // 		// console.log(giveList.fujianMsg[i].id);
    // 		if (giveList.fujianMsg[i].id == index.target.id) {
    // 			giveList.fujianMsg[i].propertyDesc = index.target.value;
    // 		}
    // 	}
    // 	delete giveList.id;
    // 	delete giveList.ids;
    // 	delete giveList.itemselector;
    // 	delete giveList.orderField;
    // 	delete giveList.orderString;
    // 	delete giveList.reqType;

    // 	// console.log(giveList);
    // 	giveList.p = this.state.alreadySearchObj.p;
    // 	giveList.s = this.state.alreadySearchObj.s;
    // 	self.setState({giveList})
    // 	// console.log(giveList);

    // 	// var giveList = self.state.giveList;
    // 	// for (var i = 0; i< giveList.bentiMsg.length ; i++) {
    // 	// 	console.log(giveList.bentiMsg[i])

    // 	// }
    // 	// console.table(giveList)
    // 	//     alert(giveList)
    //         getPro(giveList).then(result => {
    // 		if (result.status && result.code == 200) {
    // 			this.setState({
    // 				alreadyRows: result.data,
    // 				alreadyTotal: result.total
    // 			});
    // 		} else {
    // 			openNotice('error', '获取已有物料列表失败', result.message || '');
    // 		}
    // 	})
    // }

    dateOnChange = (date, dateString) => {
        if (date) {
            this.setState({add: {...this.state.add, needDate: date.valueOf()}});
        }
    }
    eaChange = (ea) => {
        if (ea) {
            this.setState({add: {...this.state.add, environmentalAttributes: ea.join(';')}});
        }
    }

    // 获取产品类别（点击搜索按钮）TODO
    getAddArray = () => {
        // 李 新增
        if (this.state.name != this.state.lastsearch) {
            this.state.addSearchObj.p = 1;
            this.state.lastsearch = this.state.name;
        }

        getProTypes({
            proLine: this.state.proLine,
            proBigType: this.state.proBigType,
            proDetailType: this.state.proDetailType,
            p: this.state.addSearchObj.p,
            s: this.state.addSearchObj.s
        }).then(result => {
            if (result.status && result.code == 200) {
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].proLine = result.data[i].subdivideProLine
                }
                this.setState({
                    addRows: result.data,
                    addTotal: result.total
                });
            } else {
                openNotice('error', '获取产品类别失败', result.message || '');
            }
        })
    }

    getAlreadyArray = () => {

    }

    getSpecList = (categoryId) => {
        fetchSpecList(categoryId).then(result => {
            if (result.status && result.code == 200) {
                // console.log(result)
                // anotherPrefixMain
                let bentiValObj = {};
                if (this.orderSession && this.orderSession.bentiSpec && this.orderSession.bentiSpec.length) {
                    const bentiSpec = this.orderSession.bentiSpec;
                    result.data.bentiMsg.forEach((x, index) => {
                        let i = bentiSpec.findIndex(y => y.propertyNum === x.propertyNum)
                        if (i > -1) {
                            bentiValObj[`anotherPrefixMain${index}`] = {val: bentiSpec[i].propertyDesc};
                        }
                    })
                }
                // anotherPrefixSlave
                let fujianValObj = {};
                if (this.orderSession && this.orderSession.fujianSpec && this.orderSession.fujianSpec.length) {
                    const fujianSpec = this.orderSession.fujianSpec;
                    result.data.bentiMsg.forEach((x, index) => {
                        let i = fujianSpec.findIndex(y => y.propertyNum === x.propertyNum)
                        if (i > -1) {
                            fujianValObj[`anotherPrefixSlave${index}`] = {val: fujianSpec[i].propertyDesc};
                        }
                    })
                }
                this.setState({
                    mainSpec: result.data.bentiMsg,
                    slaveSpec: result.data.fujianMsg,
                    giveList: JSON.parse(JSON.stringify(result.data)),
                    ...bentiValObj,
                    ...fujianValObj
                });
            } else {
                openNotice('error', '获取规格失败', result.message || '');
            }
        });
    }

    proLineChange = (event) => {
        this.setState({
            proLine: event.target.value
        });
    }

    proBigTypeChange = (event) => {
        this.setState({
            proBigType: event.target.value
        });
    }

    proDetailTypeChange = (event) => {
        this.setState({
            proDetailType: event.target.value
        });
    }

    addHandler = (event) => {
        this.setState({visible: true});
        // this.getAlreadyArray();
        // this.getSpecList();
        // if (this.state.company.length === 0) {
        // 	this.getCompanyList();
        // }
    }

    // getCompanyList = () => {
    // 	fetchCompany().then(result => {
    // 		if (result.status && result.code == 200) {
    // 			this.setState({company: result.data});
    // 		}
    // 	});
    // }

    cancelHandler = () => {
        const ds = [...this.state.submitRows];
        // debugger;
        for (let i = 0; i < this.state.selectedRowKeysOutside.length; i++) {
            for (let j = 0; j < ds.length; j++) {
                if (ds[j].id == this.state.selectedRowKeysOutside[i]) {
                    ds.splice(j, 1);
                }
            }
            // ds.splice(i, 1);
            if (i == this.state.selectedRowKeysOutside.length - 1) {
                this.setState({submitRows: ds});
            }
        }
    }

    phoneChange = (event) => {
        this.setState({
            phone: event.target.value
        });
    }

    remarkChange = (event) => {
        this.setState({
            remark: event.target.value
        });
    }

    // 点击提交
    /**
     {
       "createdBy": 2365,
       "createdDate": 1519956600381,
       "cusId": 2365,
       "cusProList": [{
         "count": 10,
         "createdBy": 2365,
         "createdDate": 1519956500381,
         "needDate": 1519956630381,
         "proBigType": "bigtype1",
         "proCompany": "company1",
         "proDetailType": "detail1",
         "proLine": "line1",
         "proMiddleType": "middle1",
         "productCode": "code1",
         "productName": "name1",
         "remark": "remark1",
         "removeFlag": 0
       }],
       "customerCode": "zhang003",
       "customerName": "王力宏",
       "phone": "13800138001",
       "remark": "",
       "removeFlag": 0,
       "userId": 2365
     }
     */
    createHandler = () => {
        if (this.state.submitRows.length == 0) {
            openNotice('error', '提交失败', '请添加定制行信息');
            return;
        }
        if (this.state.salesUnitId == '' || this.state.salesUnitId == null) {
            openNotice('error', '提交失败', '请选择购货单位');
            return;
        }
        var self = this;
        self.setState({subDisabled: true});
        // console.log(this.state.phone);
        var userData = this.state.userData;
        const {informationLi} = self.state;
        let fileList = [];
        for (let informationData of informationLi) {
            fileList.push({
                // 'fileId': informationData.id
                'attachId': informationData.id
            });
        }
        var createObj = {
            createdBy: userData.empId,
            createdDate: new Date().getTime(),
            cusId: this.state.thirdId,
            userId: this.state.customerUserId,
            cusProList: this.state.submitRows,
            customerCode: this.state.num,
            customerName: this.state.name1,
            phone: this.state.phone,
            remark: this.state.remark,
            removeFlag: 0,
            fileList: fileList,
            salesUnitId: this.state.salesUnitId,
            crmAccount: this.state.crmAccount
            // proCompany:this.state.proCompany,
            // proCompanyId:this.state.proCompanyId,
            // userId: userData.id //后端说没用
        };
        for (var i = 0; i < createObj.cusProList.length; i++) {
            delete createObj.cusProList[i].specUnionKey;
            delete createObj.cusProList[i].specifications;
            // delete createObj.cusProList[i].proContent;
        }
        // createObj.remove(specifications)
        create(createObj).then(result => {
            if (result.status && result.code == 200) {
                console.dir(result.data);
                openNotice('success', '创建成功', '');
                self.goView('customOrder');
            } else {
                openNotice('error', '创建失败', result.message || '');
                self.setState({subDisabled: false});
            }
        });
    }

    // 保存并继续
    saveAndContinue = () => {
        if (this.state.add.proCompany == '' || this.state.add.proCompanyId == '') {
            openNotice('warning', '请确认生产公司');
            return
        }
        if (this.state.add.remark == '' && this.state.add.specifications == '') {
            openNotice('warning', '请确认选型/备注内容');
            return
        }
        // if (this.state.add.environmentalAttributes == '') {
        //     openNotice('warning', '请选择环保属性');
        //     return
        // }
        this.doSave();
        // 清空各种
        this.doClear();
    }

    // 新增 点击保存
    addSaveHandler = () => {
        if (this.state.add.remark == '' && this.state.add.specifications == '') {
            openNotice('warning', '请确认选型/备注内容');
            return
        }
        if (this.state.add.proCompany == '' || this.state.add.proCompanyId == '') {
            openNotice('warning', '请确认生产公司');
            return
        }
        // if (this.state.add.environmentalAttributes == '') {
        //     openNotice('warning', '请选择环保属性');
        //     return
        // }
        this.doSave();
        this.setState({visible: false});
        this.doClear;
    }

    doSave = () => {
        // console.dir(this.state.add);
        // console.log('specifications: ' + '2000A,3P,固定式,63A');

        this.state.add.id = ++uuid;
        this.setState({submitRows: [...this.state.submitRows, this.state.add]});

    }

    doClear = () => {
        var self = this;
        // var cutImportant = {this.state.cutImportant};
        var arr = [];
        for (var name in self.state) {
            if (name.indexOf(customPrefix) > -1) {
                self.setState({[name]: ''})
            }
        }
        self.setState({
            proLine: '',
            proBigType: '',
            proDetailType: '',
            // [cutImportant] : '',
            add: {
                ...self.state.add,
                count: 1,
                specifications: '',
                specUnionKey: '',
                proContent: '',
                proCompanyId: '',
                proCompany: '',
                // needDate: '',
                remark: '',
            },
            selectedRowKeys: [],
            mainSpec: [],
            slaveSpec: []
        });
    }

    countChange = (event) => {
        this.setState({add: {...this.state.add, count: event.target.value}});
    }

    addRemarkChange = (event) => {
        if (event.target.value.length > 1000) {
            return
        }
        this.setState({add: {...this.state.add, remark: event.target.value}});
    }

    companyChange = (value, option) => {
        // console.log(value);
        let messagess = this.state.company.filter(x => x.id == parseInt(value))[0];
        // var index = option.props.recordIndex;
        // console.log(messagess)
        this.setState({add: {...this.state.add, proCompany: messagess.name, proCompanyId: messagess.id}});
        // this.setState({proCompany: messagess.name,proCompanyId:messagess.id});
        // 	...this.state,
        // 	submitRows: this.state.submitRows.map((x, index) => {
        // 		if(index == option.props.recordIndex){
        // 			return {
        // 				...x,
        // 				pickProAddress: value
        // 			}
        // 		}else{
        // 			return x
        // 		}
        // 	})
        // })
    }
    onCompanyChange = (value) => {
        this.setState({
            selectcompany: value,
        });
    }

    CascaderonChange = (value, selectedOptions) => {
        if (value != '') {
            this.setState({proDetailType: selectedOptions[2].label, categoryCascaderValue: value});
            this.state.addSearchObj.p = 1;
            console.log('debug this.state.proLine', this.state.proLine);
            console.log('debug this.state.proBigType', this.state.proBigType);
            getProTypes({
                proLine: this.state.proLine,
                proBigType: this.state.proBigType,
                proDetailType: selectedOptions[2].label,
                p: 1,
                s: this.state.addSearchObj.s
            }).then(result => {
                if (result.status && result.code == 200) {
                    for (var i = 0; i < result.data.length; i++) {
                        result.data[i].proLine = result.data[i].subdivideProLine
                    }
                    this.setState({
                        loading: false,
                        addRows: result.data,
                        addTotal: result.total
                    });
                } else {
                    this.setState({
                        loading: false,
                        addRows: [],
                        addTotal: 0
                    });
                    openNotice('error', '获取产品类别失败', result.message || '');
                }
            })
        }
    }


    cascaderFilter = (inputValue, path) => {
        return (path.some(option => (option.label).toUpperCase().indexOf(inputValue.toUpperCase()) > -1));
    }


    addToCar = (value, record, index) => {
        // console.log(value);
        // console.log(record);
        var params = {
            productId: value.id,
            count: parseInt(this.state.add.count),
        };
        addCar(params).then(result => {
            openNotice('success', '创建成功', '');
        })
    }

    onSelectRow = (record, cb) => {
        var selectedRowKeys = this.state.selectedRowKeys;
        selectedRowKeys[0] = record.categoryId;
        this.setState({
            selectedRowKeys: selectedRowKeys,
        });
        fetchCompany(record.categoryId).then(result => {
            if (result.status && result.code == 200) {
                this.setState({company: result.data});
                if (result.data.length > 1) {
                    this.setState({selectcompany: ''})
                } else {
                    this.setState({selectcompany: result.data[0].name})
                    this.setState({
                        add: {
                            ...this.state.add,
                            proCompany: result.data[0].name,
                            proCompanyId: result.data[0].id
                        }
                    });
                }
                ;
            }
        });

        var self = this;
        this.doClear();
        this.setState({
            selectedRowKeys: selectedRowKeys,
            add: {
                ...this.state.add,
                specifications: [],
                specUnionKey: [],
                proContent: '',
                subdivideProLine: record.subdivideProLine,
                proBigType: record.proBigType,
                proMiddleType: record.proMiddleType,
                proDetailType: record.proDetailType,
                proLine: record.proLine
            },
            alreadyRows: []
        }, () => {
            if (cb && typeof cb === 'function') {
                cb()
            }
            self.getSpecList(record.categoryId);
        });
    }

    changeName = (itm) => {
        this.state.options1.find(item => {
            if (item.thirdId === itm) {
                this.setState({
                    thirdId: item.thirdId,
                    customerUserId: item.customerUserId,
                    num: item.code,
                    name1: item.name
                });
            }
        })
        // this.setState({thirdId:1,num:1,name1:1});
    }

    onSelectChangeGouHuoUnit = (item) => {
        this.setState({
            salesUnitId: Number(item)
        });
    }


    changeCrmAccount = (value) => {
        this.setState({crmAccount: value});
        fetchCrmAccount(value, data => this.setState({crmAccountList: data}))
    }

    render() {
        var self = this;
        const {
            opts,
            key,
            total,
            informationProps,
            searchObj,
            selectedRowKeys,
            selectedRowKeysOutside,
            visible,
            addRows,
            addTotal,
            addSearchObj,
            alreadyRows,
            alreadyTotal,
            alreadySearchObj,
            phone,
            remark,
            userData,
            company,
            num,
            options1,
            loading,
            informationLi,
            categoryCascaderValue,
            cascaderOption,
            thirdId,
            gouxiaoUnitList
        } = this.state;
        // console.log(userData);
        // debugger
        let informationHtml = (informationLi || []).map(function (ele, key) {
            return <div className="edit_upload_information" key={key}>
                <span>{ele.fileName}</span>
                <i className="anticon anticon-delete" onClick={self.deleteInformation.bind(self, key)}></i>
            </div>
        });
        const crmAccountOptions = this.state.crmAccountList.map(d => <Option key={d.value}>{d.text}</Option>);
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '产品线',
                    dataIndex: 'proLine'
                }, {
                    title: '大类',
                    dataIndex: 'proBigType'
                },
                {
                    title: '中类',
                    dataIndex: 'proMiddleType'
                },
                {
                    title: '明细类',
                    dataIndex: 'proDetailType'
                },
                {
                    title: '物料名称',
                    dataIndex: 'proContent',
                    width: '260px',
                },
                {
                    title: '规格',
                    dataIndex: 'specUnionKey',
                    width: '260px',
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                },
                {
                    title: '生产公司',
                    dataIndex: 'proCompany'
                },
                {
                    title: '数量',
                    dataIndex: 'count'
                },
                {
                    title: '环保属性',
                    dataIndex: 'environmentalAttributes'
                },
                {
                    title: '需求日期',
                    dataIndex: 'needDate',
                    render: text => {
                        return moment(+text).format('YYYY-MM-DD')
                    }
                }
            ],
            rows: this.state.submitRows,
            rowSelection: {selectedRowKeys: selectedRowKeysOutside, onChange: self.onOutsideSelectChange}
        };
        const addProps = {
            rowKey: 'categoryId',
            loading: loading,
            pageParam: {
                total: addTotal,
                current: addSearchObj.p,//当前页码
                pageSize: addSearchObj.s,//当前分页数
                onChange: this.addPageChange
            },
            columns: [
                {
                    title: '产品线',
                    dataIndex: 'proLine'
                },
                /*{
                    title: '产品线',
                    dataIndex: 'subdivideProLine'
                },*/
                {
                    title: '物料大类',
                    dataIndex: 'proBigType'
                },
                {
                    title: '物料中类',
                    dataIndex: 'proMiddleType'
                },
                {
                    title: '明细类',
                    dataIndex: 'proDetailType'
                }],
            rows: addRows,
            rowSelection: {selectedRowKeys, onChange: self.onSelectChange, onSelect: self.onSelfRow, type: 'radio'},
            onRowClick: (record, index, event) => this.onSelectRow(record)
        }

        const alreadyProps = {
            rowKey: 'id',
            loading: false,
            pageParam: {
                total: alreadyTotal,
                current: alreadySearchObj.p,//当前页码
                pageSize: alreadySearchObj.s,//当前分页数
                onChange: this.alreadyPageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                },
                {
                    title: '物料名称',
                    dataIndex: 'name',
                    render: text => <span style={{whiteSpace: 'pre'}}>{text}</span>
                },
                {
                    title: '物料大类',
                    dataIndex: 'proBigName'
                },
                {
                    title: '规格',
                    dataIndex: 'categoryText'
                },
                {
                    title: '牌价',
                    dataIndex: 'showPrice'
                },
                {
                    title: '最小起订量',
                    dataIndex: 'minPackageQuantity'
                },
                {
                    title: '最小装箱数',
                    dataIndex: 'minOrderQuantity'
                },
                {
                    title: '装箱数',
                    dataIndex: 'packageQuantity'
                },
                {
                    title: '库存类型',
                    dataIndex: 'stockType'
                },
                {
                    title: '操作',
                    render: (text, record, index) => {
                        return <Button onClick={this.addToCar.bind(this, record, index)}>加入购物车</Button>;
                    }
                }],
            rows: alreadyRows
        }

        const radioLayout = {marginLeft: 10},
            radioButtonLayout = {marginRight: 10};

        var mainRenderer = (this.state.mainSpec || []).map((ele, index) => {
            var radioOptionsRenderer = (ele.propertyDescName || []).map((e, i) => {
                return <RadioButton style={radioButtonLayout} key={i} id={ele.id} name={ele.propertyName} value={e}
                                    onClick={this.radioBtnChange2.bind(this, index, e, 0, ele, i)}>{e}</RadioButton>
            });
            if (index > 0) {
                return (
                    <div className="dms-spec-radio-group" key={index}
                         style={{marginBottom: index === this.state.mainSpec.length - 1 ? 0 : 10}}>
                        <hr style={{marginBottom: '14px', height: '1px'}}/>
                        <div style={{fontWeight: 'bold'}}><Icon type="logout"
                                                                style={{paddingLeft: '1px'}}/> {ele.propertyName}</div>
                        <RadioGroup
                            value={this.state['anotherPrefixMain' + index] && this.state['anotherPrefixMain' + index].val}
                            style={radioLayout} onChange={this.radioOnChange2}>
                            {radioOptionsRenderer}
                        </RadioGroup>
                    </div>
                )
            } else {
                return (
                    <div className="dms-spec-radio-group" key={index}
                         style={{marginBottom: index === this.state.mainSpec.length - 1 ? 0 : 10}}>
                        <div style={{fontWeight: 'bold'}}><Icon type="logout"
                                                                style={{paddingLeft: '1px'}}/> {ele.propertyName}</div>
                        <RadioGroup
                            value={this.state['anotherPrefixMain' + index] && this.state['anotherPrefixMain' + index].val}
                            style={radioLayout} onChange={this.radioOnChange2}>
                            {radioOptionsRenderer}
                        </RadioGroup>
                    </div>
                )
            }
        });

        var slaveRenderer = (this.state.slaveSpec || []).map((ele, index) => {
            var radioOptionsRenderer = (ele.propertyDescName || []).map((e, i) => {
                return <RadioButton style={radioButtonLayout} key={i} id={ele.id} name={ele.propertyName} value={e}
                                    onClick={this.radioBtnChange2.bind(this, index, e, 1, ele, i)}>{e}</RadioButton>
            });
            if (index > 0) {
                return (
                    <div className="dms-spec-radio-group" key={index}
                         style={{marginBottom: index === this.state.slaveSpec.length - 1 ? 0 : 10}}>
                        <hr style={{marginBottom: '14px', height: '1px'}}/>
                        <div style={{fontWeight: 'bold'}}><Icon type="logout"
                                                                style={{paddingLeft: '1px'}}/> {ele.propertyName}</div>
                        <RadioGroup
                            value={this.state['anotherPrefixSlave' + index] && this.state['anotherPrefixSlave' + index].val}
                            style={radioLayout} onChange={this.radioOnChange2}>
                            {radioOptionsRenderer}
                        </RadioGroup>
                    </div>
                )
            } else {
                return (
                    <div className="dms-spec-radio-group" key={index}
                         style={{marginBottom: index === this.state.slaveSpec.length - 1 ? 0 : 10}}>
                        <div style={{fontWeight: 'bold'}}><Icon type="logout"
                                                                style={{paddingLeft: '1px'}}/> {ele.propertyName}</div>
                        <RadioGroup
                            value={this.state['anotherPrefixSlave' + index] && this.state['anotherPrefixSlave' + index].val}
                            style={radioLayout} onChange={this.radioOnChange2}>
                            {radioOptionsRenderer}
                        </RadioGroup>
                    </div>
                )
            }
        });

        return <div>
            <DmsTab options={opts} defaultKey={key}>
                <Button onClick={this.createHandler} disabled={this.state.subDisabled}>提交</Button>
                <Button onClick={this.goBack}>返回</Button>
            </DmsTab>
            <div className="dms-table-box">
                <div style={{color: 'red'}}>为保证大客户质量要求，请在【定制需求方】输入完整的大客户名称
                </div>
                <Row>
                    <Col span={6}>
                        <label>编号：</label>
                        <span></span>
                    </Col>
                    <Col span={6}>
                        <label>状态：</label>
                        <span></span>
                    </Col>
                    <Col span={6}>
                        <label>订单日期：</label>
                        <span></span>
                    </Col>
                    <Col span={6}>
                        <label>客户编号：</label>
                        <span>{num}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={6} style={{marginTop: 10}}>
                        <label>客户名称：</label>
                        {/*<span>{userData.userName}</span>*/}
                        <Select style={{width: 220}} onChange={this.changeName.bind(this)} value={thirdId}>
                            {
                                options1.map(function (ele, itm) {
                                    return <Select.Option key={ele.thirdId}
                                                          value={ele.thirdId}>{ele.name}</Select.Option>
                                })
                            }
                        </Select>
                        {/*<Select style={{ width: 400 }} onChange={this.cusNameChange}>
			 {	options1.map(function(cur, ind) {
			 return <Option key={ind} value={cur.thirdId + ''}>{cur.name}</Option>;
			 })
			 }
			 </Select>*/}
                    </Col>
                    <Col span={6} style={{marginTop: 10}}>
                        <label>购货单位：</label>
                        <Select
                            value={this.state.salesUnitId}
                            placeholder="请选择购货单位"
                            style={{minWidth: 250}}
                            onSelect={this.onSelectChangeGouHuoUnit}
                        >
                            {
                                gouxiaoUnitList.map((item, index) => {
                                    return <Select.Option key={item.value}
                                                          value={item.value}>{item.text}</Select.Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={6} style={{marginTop: 10}}>
                        <label>定制需求方：</label>
                        <Select
                            mode="combobox"
                            value={this.state.crmAccount}
                            placeholder="请选择定制需求方"
                            notFoundContent=""
                            style={{minWidth: 250}}
                            defaultActiveFirstOption={false}
                            showArrow={false}
                            filterOption={false}
                            onChange={this.changeCrmAccount}
                        >
                            {crmAccountOptions}
                        </Select>
                    </Col>
                    <Col span={6} style={{marginTop: 10}}>
                        <label>联系电话：</label>
                        <Input value={phone} style={{width: 150}} onChange={this.phoneChange}/>
                    </Col>
                </Row>
                <Row>
                    <Col span={18} style={{marginTop: 10}}>
                        <label>备注：</label>
                        <Input value={remark} style={{width: 1000}} onChange={this.remarkChange}/>
                    </Col>
                </Row>
            </div>
            <div>
                <DmsTab className="white-bg no-border" options={['订单物料']} defaultKey={0}/>
                <div className="dms-table-box">
                    <div style={{marginBottom: 8}}>
                        <Button onClick={this.addHandler}>新增</Button>
                        <Button style={{marginLeft: 10}} onClick={this.cancelHandler.bind(this)}>删除</Button>
                    </div>
                    <TableView {...tableViewProps} />
                </div>
            </div>

            <Modal
                visible={visible}
                title="新增定制订单"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={1000}
                style={{top: 20}}
                footer={null}
            >
                <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <div><label className="ant-form-item-required">选择产品类别</label></div>
                        <Row>
                            {/*<Col span={6}><label>产品线：</label><Input style={{width:100}} value={this.state.proLine} onChange={this.proLineChange}/></Col>*/}
                            <Col span={6}><Cascader style={{width: '300px'}}
                                                    options={cascaderOption}
                                                    value={categoryCascaderValue}
                                                    onChange={this.CascaderonChange}
                                                    placeholder="请选择产品分类"
                                                    showSearch={{filter: this.cascaderFilter}}
                            /></Col>
                        </Row>
                        <TableView {...addProps} bordered style={{marginTop: 10}}/>
                    </section>

                    <section className="section-bordered">
                        <div className="section-title">选型</div>
                        <Tabs type="card">
                            <TabPane tab="本体" key="1">
                                {
                                    mainRenderer
                                }
                            </TabPane>
                            <TabPane tab="附件" key="2">
                                {
                                    slaveRenderer
                                }
                            </TabPane>
                        </Tabs>
                    </section>

                    <section className="section-bordered">
                        <Row>
                            <Col span={6}>
                                <label className="ant-form-item-required">数量：</label>
                                <Input style={{width: 100}} value={this.state.add.count || 1}
                                       onChange={this.countChange}
                                       type='number' min="1"/>
                            </Col>
                            <Col span={6}>
                                <label>生产公司：</label>
                                <Select style={{width: 150}} onSelect={this.companyChange.bind(this)}
                                        value={this.state.selectcompany}
                                        onChange={this.onCompanyChange}
                                >
                                    {
                                        company.map(function (ele, ind) {
                                            return <Select.Option key={ind}
                                                                  value={ele.id + ''}>{ele.name}</Select.Option>
                                        })
                                    }
                                </Select>
                            </Col>
                            <Col span={12}>
                                <label>已选：</label>
                                <label>{this.state.add.specifications}</label>
                            </Col>
                        </Row>
                        <Row style={{marginTop: 10}}>
                            <Col span={6}>
                                <label className="ant-form-item-required">需求日期：</label>
                                <DatePicker defaultValue={moment(new Date())} onChange={this.dateOnChange}
                                            style={{width: 120}}/>
                            </Col>
                            <Col span={18}>
                                <label>环保属性：</label>
                                <Select mode="multiple" style={{width: 500}} onChange={this.eaChange.bind(this)}
                                        disabled={true}>
                                    <Option key={'RoHS'}>RoHS</Option>
                                    <Option key={'REACH'}>REACH</Option>
                                    <Option key={'包装指令'}>包装指令</Option>
                                    <Option key={'无卤素'}>无卤素</Option>
                                    <Option key={'无红磷'}>无红磷</Option>
                                    <Option key={'无'}>无</Option>
                                </Select>
                            </Col>
                        </Row>
                        <Row style={{marginTop: 10}}>
                            <Col>
                                <label>备注：</label>
                                <Input value={this.state.add.remark} onChange={this.addRemarkChange}/>
                            </Col>
                        </Row>
                        {/*<Row style={{ marginTop: 10 }}>
                <Col>
                  <div style={{padding: '12px', background: '#fff'}}>
                      <label>附件：</label>
                      <Upload {...informationProps} >
                          <Button>
                              <Icon type="upload" /> 上传附件
                          </Button>
                      </Upload>
                              {informationHtml}
                  </div>
                </Col>
              </Row>*/}
                    </section>

                    <Row type="flex" justify="center" style={{marginTop: 15}}>
                        <Col>
                            <Button onClick={this.saveAndContinue}>保存并继续</Button>
                        </Col>
                        <Col offset={1}>
                            <Button onClick={this.addSaveHandler}>保存</Button>
                        </Col>
                    </Row>

                    <section className="section-bordered">
                        <div><p>已有物料列表<span
                            style={{
                                color: '#d61518',
                                fontSize: 'xx-small',
                                marginLeft: 20
                            }}>注意：以下为公司已有物料，无需定制可直接下单。</span>
                        </p></div>
                        <TableView {...alreadyProps} bordered style={{marginTop: 10}}/>
                    </section>

                </div>
            </Modal>

        </div>
    }
}
;
export default withRouter(CustomOrderAdd);



// WEBPACK FOOTER //
// ./src/routes/customOrder/add.js